export enum eTaxAuthorityType {
  state = 'state',
  county = 'county',
  city = 'city',
  local = 'local',
}
